import React, { useState } from 'react';
import '../styles/components/FilterModal.scss';
import FilterSidebar from './FilterSidebar';

const FilterModal = ({ show, onClose, initial, onApply }) => {
  if (!show) return null;
  return (
    <div className="FilterModal">
      <div className="FilterModal__backdrop" onClick={onClose} />
      <div className="FilterModal__content">
        <button className="FilterModal__close" onClick={onClose}>×</button>
        <FilterSidebar
          initial={initial}
          onChange={(f) => {
            onApply(f);
            onClose();
          }}
        />
      </div>
    </div>
  );
};

export default FilterModal;
